import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { YStack, Text } from 'tamagui';

import { PinIndicator } from './PinIndicator';

interface PinEntryStepProps {
  type: 'set' | 'reset' | 'disable';
  step: number;
  pin: string[];
  setPin: React.Dispatch<React.SetStateAction<string[]>>;
  onSuccess: () => void;
  validPin: string[] | null;
  error?: string | null;
}

export const PinEntryStep: React.FC<PinEntryStepProps> = ({
  type,
  step,
  pin,
  setPin,
  onSuccess,
  validPin,
}) => {
  const [pinError, setPinError] = useState<string | null>(null);
  const { t } = useTranslation();

  const title = {
    1:
      type === 'disable'
        ? t('settings.lockScreen.enterCurrentPinForDisable')
        : t('settings.lockScreen.enterCurrentPin'),
    2: t('settings.lockScreen.enterNewPin'),
    3: t('settings.lockScreen.confirmNewPin'),
  }[step];

  useEffect(() => {
    if (!pin.includes('')) {
      if (!validPin || pin.join('') === validPin.join('')) {
        onSuccess();
      } else {
        setPinError('Incorrect PIN. Please try again.');
        setTimeout(() => setPinError(null), 1500);
        setPin(['', '', '', '']);
      }
    }
  }, [pin]);

  return (
    <YStack flex={1} alignItems="center" gap="$5">
      <Text fontSize="$6" color="$white12">
        {title}
      </Text>
      <PinIndicator pin={pin} pinError={pinError} />
    </YStack>
  );
};
